import { useEffect, useRef, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import Nav from "@/components/beachbreak/Nav";
import Hero from "@/components/beachbreak/Hero";
import Marquee from "@/components/beachbreak/Marquee";
import WhyBreak from "@/components/beachbreak/WhyBreak";
import WaysToPlay from "@/components/beachbreak/WaysToPlay";
import MeetTess from "@/components/beachbreak/MeetTess";
import InAction from "@/components/beachbreak/InAction";
import FAQ from "@/components/beachbreak/FAQ";
import InterestList from "@/components/beachbreak/InterestList";
import Footer from "@/components/beachbreak/Footer";
import Admin from "@/components/beachbreak/Admin";
import AuthCallback from "@/components/beachbreak/AuthCallback";
import GetawayPage from "@/components/beachbreak/GetawayPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-cream flex items-center justify-center p-8 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-deep">
            Something broke the wave — refresh the page.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Landing = () => {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-cream text-deep">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <WaysToPlay />
        <WhyBreak />
        <MeetTess />
        <InAction />
        <FAQ />
        <InterestList />
      </main>
      <Footer />
    </div>
  );
};

const AppRouter = () => {
  const location = useLocation();
  // Detect the OAuth session_id during render (reactive), before any auth check runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/getaway" element={<GetawayPage />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
